import React from 'react';
import { Link, graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import Img from 'gatsby-image';
import getShareImage from '@jlengstorf/get-share-image';
import Layout from '../components/layout';
import SEO from '../components/seo/seo';
import CTA from '../components/CTA';
import ShareButton from '../components/ShareButton';

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.mdx;
  const siteTitle = data.site.siteMetadata.title;
  const { previous, next } = pageContext;
  const socialImage = getShareImage({
    title: post.frontmatter.title,
    cloudName: 'du2cnzqic',
    imagePublicID: 'shopfeedback-og-image-blank_ywci01',
    titleFont: 'poppins',
    textColor: '2F4858',
    titleGravity: 'center',
    titleExtraConfig: '_bold_line_spacing_-20_center',
    titleBottomOffset: 0,
    titleLeftOffset: 200,
  });
  const { title, description, date, image } = post.frontmatter;
  const escapedTitle = encodeURIComponent(title);

  const twitterLink = `https://twitter.com/intent/tweet/?text=${escapedTitle}&amp;url=${location.href}`;
  const fbLink = `https://facebook.com/sharer/sharer.php?u=${location.href}`;
  // const linkedInLink = `https://www.linkedin.com/shareArticle?mini=true&url=${location.href}&title=${escapedTitle}`;

  return (
    <Layout>
      <SEO
        title={title}
        description={description || post.excerpt}
        pathname={location.pathname}
        socialImage={socialImage}
      />
      <article className="px-4 w-full md:w-3/4 lg:w-2/3 2xl:w-1/2 mx-auto pt-8">
        <header className="pb-6 flex self-center justify-center flex-col">
          <h1 className="leading-tight font-sans text-shop-dark-green text-4xl md:text-5xl mb-4">
            {title}
          </h1>
          <p className="text-gray-500 text-sm">{date}</p>
        </header>
        {image && (
          <Img
            fluid={image.childImageSharp.fluid}
            className="mb-8 shadow-lg rounded"
          />
        )}
        <section className="blog-post">
          <MDXRenderer>{post.body}</MDXRenderer>
        </section>
        <section>
          <hr className="my-8" />
          <div className="flex justify-center md:justify-start mb-8">
            <ShareButton type="Twitter" link={twitterLink} />
            <ShareButton type="Facebook" link={fbLink} />
            {/* <ShareButton type="LinkedIn" link={linkedInLink} /> */}
          </div>
        </section>
      </article>
      <CTA />
    </Layout>
  );
};

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      body
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        image {
          childImageSharp {
            fluid(maxWidth: 600, maxHeight: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
